import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const SeatIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SeatGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M19.0644 18.862H10.2629C8.20816 18.862 6.37556 17.483 5.80619 15.5095L2.61275 4.44369C2.33684 3.48708 2.85574 2.4767 3.79425 2.14321C5.05859 1.68794 6.46772 2.35165 6.93725 3.60885L10.4993 13.1552C10.6968 13.684 11.2212 14.0032 11.7856 13.9275L18.6772 13.0115C19.518 12.9062 20.3628 13.1574 21.0001 13.7147C21.6364 14.2731 22.0017 15.0783 22.0017 15.9242C22.0017 17.5445 20.6842 18.862 19.0644 18.862ZM3.69222 4.13213L6.88568 15.1979C7.31736 16.6943 8.70621 17.7386 10.2629 17.7386H19.0644C20.0643 17.7386 20.8783 16.9246 20.8783 15.9242C20.8783 15.402 20.6529 14.9039 20.2596 14.5595C19.8669 14.215 19.3474 14.0548 18.8252 14.1261L11.9337 15.0421C10.8498 15.1793 9.82956 14.5715 9.44725 13.548L5.88518 4.0016C5.62957 3.31595 4.8622 2.95503 4.16996 3.20187C3.79094 3.3357 3.58087 3.74489 3.69222 4.13213Z"
        fill={fill}
      />
      <path
        d="M9.63321 12.9216C9.40283 12.9216 9.19056 12.779 9.10773 12.5562L8.17965 10.0693C8.12095 9.91349 8.13522 9.73906 8.21749 9.59426C8.30032 9.44944 8.44293 9.34962 8.60694 9.32L14.8666 8.19993C15.8814 8.01782 16.8522 8.69798 17.0333 9.71055C17.121 10.2009 17.0124 10.6968 16.7272 11.106C16.4425 11.5152 16.0152 11.7894 15.5243 11.8772L9.7325 12.9128C9.69959 12.9183 9.66612 12.9216 9.63321 12.9216ZM9.46701 10.3073L9.99633 11.7247L15.3263 10.7714C15.5215 10.7363 15.6921 10.6277 15.8057 10.4642C15.9192 10.3008 15.9625 10.1033 15.9274 9.90801C15.8556 9.5043 15.4683 9.23772 15.0635 9.30574L9.46701 10.3073Z"
        fill={fill}
      />
      <path
        d="M18.8735 21.9995H8.70566C8.3952 21.9995 8.14398 21.7483 8.14398 21.4378C8.14398 21.1274 8.3952 20.8762 8.70566 20.8762H18.8735C19.184 20.8762 19.4352 21.1274 19.4352 21.4378C19.4352 21.7483 19.184 21.9995 18.8735 21.9995Z"
        fill={fill}
      />
    </svg>
  );
};

export default SeatIcon;
